export var ToolPosition;
(function (ToolPosition) {
    ToolPosition["Top"] = "T";
    ToolPosition["Bottom"] = "B";
    ToolPosition["Left"] = "L";
    ToolPosition["Right"] = "R";
    ToolPosition["UpperLeft"] = "UL";
    ToolPosition["UpperRight"] = "UR";
    ToolPosition["UpperMidLeft"] = "UML";
    ToolPosition["UpperMidRight"] = "UMR";
    ToolPosition["LowerMidLeft"] = "LML";
    ToolPosition["LowerMidRight"] = "LMR";
    ToolPosition["LowerLeft"] = "LL";
    ToolPosition["LowerRight"] = "LR";
})(ToolPosition || (ToolPosition = {}));
export var DeviceKind;
(function (DeviceKind) {
    DeviceKind["Mobile"] = "mobile";
    DeviceKind["Desktop"] = "desktop";
})(DeviceKind || (DeviceKind = {}));
//# sourceMappingURL=device.types.js.map